"use client";

import { HttpError, request } from "@/lib/api/http";

export const fetchFromBackend = async <T = unknown>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> => {
  try {
    return await request<T>(endpoint, options);
  } catch (err) {
    if (err instanceof HttpError) {
      const bodyMessageRaw =
        err.body && typeof err.body === "object" && "message" in err.body
          ? (err.body as { message?: unknown }).message
          : undefined;
      const bodyMessage =
        typeof bodyMessageRaw === "string"
          ? bodyMessageRaw
          : Array.isArray(bodyMessageRaw)
            ? bodyMessageRaw.filter((v) => typeof v === "string").join(", ")
            : "";
      throw new Error(`HTTP ${err.status}: ${bodyMessage || err.message}`);
    }
    throw err;
  }
};
